<template>
  <el-col :span="4">
    <div :class="[ checked ? 'folder-wrapper is-selected' : 'folder-wrapper' ]">
      <div class="folder-border">
        <div class="folder-inner c-dblclick" @dblclick.self="onDblClickImg" @click.self="onClickImgBox">
          <el-checkbox v-model="checked"></el-checkbox>
        </div>
      </div>
      <div class="folder-title" style="height: 30px;">
        <span v-show="!editing" @dblclick="onDblClickName">{{data.customimagetypeName}}</span>
        <el-input v-show="editing" ref="nameField" placeholder="Please input" @keyup.native.enter="$refs.nameField.blur()" v-model="data.customimagetypeName" @blur="editing = false" @change="handleChange"></el-input>
      </div>
    </div>
  </el-col>
</template>
<!-- 0306 추가 -->
<style lang="scss" scoped>
.el-col {width: 197px}
@media only screen and (max-width: 1455px) {
  .el-col {width: 197px}
}
</style>
<script>
export default {
  name: 'WImgBoxForGroup',
  props: {
    data: {
      type: Object,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      checked: false,
      editing: false,
      name: this.value === undefined || this.value === null ? '' : this.value,
    };
  },
  watch: {
    value(val) {
      this.name = val;
    },
    editing(val) {
      if (val === true) {
        this.$nextTick(() => {
          this.$refs.nameField.focus();
        });
      } else if (val === false && !this.data.customimagetypeId) {
        // 새폴더인 경우 초기 이름 수정 후 바로 DB에 등록한다.
        this.$emit('add-img-group', this.data.customimagetypeName);
      }
    },
    data: {
      immediate: true,
      handler(value) {
        this.checked = (value.checked) ? value.checked : false;
        if (!value.customimagetypeId) {
          this.editing = true;
        }
      },
    },
    /**
     * 폴더 선택시 부모 컴포넌트에 이벤트 emit
     * @param  {[type]} checked [description]
     * @return {[type]}         [description]
     * @author jda
     */
    checked(checked) {
      this.$emit('check-change', this.data, checked);
    },
  },
  methods: {
    onClickImgBox() {
      this.checked = !this.checked;
    },
    handleChange(val) {
      // this.$emit('input', val);
      if (this.data.customimagetypeId) {
        const params = {
          customimagetypeId: this.data.customimagetypeId,
          customimagetypeName: val,
        };
        this.$emit('change-group-name', params);
      }
    },
    onDblClickName() {
      this.editing = !this.editing;
    },
    onDblClickImg() {
      this.$emit('dblclick-img', this.data);
    },
    setChecked(value) {
      this.checked = value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/ImageSettings/ImageSettingsView/components/ImgBoxForGroup.vue